interface Props {
  wrapper: (children: React.ReactNode) => React.ReactNode;
  children: React.ReactNode;
}

export const Wrapper = ({ wrapper, children }: Props) => {
  return <>{wrapper(children)}</>;
};
